import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import DateTypeFilter from "./components/DateTypeFilter";
import LookupFilter from "./components/LookupFilter";
import BooleanFilter from "./components/BooleanFilter";
import DefaultFilter from "./components/DefaultFilter";

export default function TableFilter(props) {
	const {
		columns: originalColumns,
		selection,
		filterCellStyle,
		emptyCell,
		actionsColumnIndex,
		isTreeData,
		hasDetailPanel,
		hasActions,
		onFilterChanged,
		icons,
		localization
	} = props;

	function getComponentForColumn(columnDef) {
		if (columnDef.filtering === false) {
			return null;
		}

		if (columnDef.field || columnDef.customFilterAndSearch) {
			if (columnDef.lookup) {
				return (
					<LookupFilter columnDef={columnDef} onFilterChanged={onFilterChanged} />
				);
			} else if (columnDef.type === "boolean") {
				return (
					<BooleanFilter columnDef={columnDef} onFilterChanged={onFilterChanged} />
				);
			} else if (["date", "datetime", "time"].includes(columnDef.type)) {
				return (
					<DateTypeFilter columnDef={columnDef} onFilterChanged={onFilterChanged} />
				);
			} else {
				return (
					<DefaultFilter
						columnDef={columnDef}
						onFilterChanged={onFilterChanged}
						icons={icons}
						localization={localization}
					/>
				);
			}
		}
	}

	const columns = originalColumns
		.filter(
			columnDef => !columnDef.hidden && !(columnDef.tableData.groupOrder > -1)
		)
		.sort((a, b) => a.tableData.columnOrder - b.tableData.columnOrder)
		.map(columnDef => (
			<TableCell
				key={columnDef.tableData.id}
				style={{ ...filterCellStyle, ...columnDef.filterCellStyle }}
			>
				{getComponentForColumn(columnDef)}
			</TableCell>
		));

	if (selection) {
		columns.splice(0, 0, <TableCell padding="none" key="key-selection-column" />);
	}

	if (emptyCell && hasActions) {
		if (actionsColumnIndex === -1) {
			columns.push(<TableCell key="key-action-column" />);
		} else {
			let endPos = 0;
			if (selection) {
				endPos = 1;
			}
			columns.splice(
				actionsColumnIndex + endPos,
				0,
				<TableCell key="key-action-column" />
			);
		}
	}

	if (hasDetailPanel) {
		columns.splice(
			0,
			0,
			<TableCell padding="none" key="key-detail-panel-column" />
		);
	}

	if (isTreeData > 0) {
		columns.splice(
			0,
			0,
			<TableCell padding="none" key={"key-tree-data-filter"} />
		);
	}

	originalColumns
		.filter(columnDef => columnDef.tableData.groupOrder > -1)
		.forEach(columnDef => {
			columns.splice(
				0,
				0,
				<TableCell
					padding="checkbox"
					key={"key-group-filter" + columnDef.tableData.id}
				/>
			);
		});

	return <TableRow style={{ height: 10 }}>{columns}</TableRow>;
}
